import { createGlobalStyle } from 'styled-components';

import normalize from './normalize';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing:border-box;
    font-family: 'Open Sans', 'Roboto', 'Noto Sans SC', sans-serif !important;
  }
  #root {
    margin: 0 auto;
  }
  ${normalize}
`;
